import { supabase } from '@/integrations/supabase/client'

export async function fetchAllRows<T>(
  table: string,
  selectString: string,
  filterFn: (query: any) => any,
  pageSize = 1000
): Promise<T[]> {
  let page = 0
  let allRows: T[] = []
  let done = false

  while (!done) {
    let query = supabase.from(table).select(selectString)
    query = filterFn(query).range(page * pageSize, (page + 1) * pageSize - 1)
    const { data, error } = await query

    if (error) throw error
    if (!data || data.length === 0) {
      done = true
    } else {
      allRows = allRows.concat(data)
      if (data.length < pageSize) done = true
      else page += 1
    }
  }
  return allRows
}

export async function fetchAllRowsByIds<T>(
  table: string,
  selectString: string,
  column: string,
  ids: string[],
  batchSize = 30
): Promise<T[]> {
  if (ids.length === 0) return []

  const batches: string[][] = []
  for (let i = 0; i < ids.length; i += batchSize) {
    batches.push(ids.slice(i, i + batchSize))
  }

  const results = await Promise.all(
    batches.map((batch) =>
      fetchAllRows<T>(table, selectString, (q) => q.in(column, batch))
    )
  )

  return results.flat()
}
